import { Box, Card, Typography } from "@material-ui/core";
import { EditButton } from "common/components/EditButton";
import DeleteIcon from "common/icons/DeleteIcon";
import EditIcon from "common/icons/EditIcon";
import { t } from "i18next";
import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import { IApplicationState } from "redux/root-reducer";

export const PhoneNumbers = ({
  onEdit,
  onRemove,
}: {
  onEdit: (number: string) => void;
  onRemove: (number: string) => void;
}) => {
  const { PhoneNumbers } = useSelector(
    (state: IApplicationState) => state.common.currentUserInfo
  );

  if (!PhoneNumbers) return null;

  return (
    <>
      {PhoneNumbers.map((number, i) => (
        <Fragment key={i}>
          <Card
            key={i}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="h3">{number}</Typography>
            <Box display="flex" style={{ gap: 15 }} alignSelf="flex-end">
              <EditButton
                title={t("Edit")}
                icon={<EditIcon height={20} />}
                onClick={() => onEdit(number)}
              />
              <EditButton
                title={t("Remove")}
                icon={<DeleteIcon height={20} />}
                iconColor="var(--color-red)"
                onClick={() => onRemove(number)}
              />
            </Box>
          </Card>
        </Fragment>
      ))}
    </>
  );
};
